import { useGetUserProfile } from '@/api/user-dashboard/queries';

import { AddFundDocumentModal } from './add-fund-document-modal';
import { AddressBookCategoriesModal } from './address-book-categories-modal';
import { BlockActionModal } from './block-action-modal';
import { ConfirmActionModal } from './confirm-action-modal';
import { CreateNewFundModal } from './create-new-fund-modal';
import { CustomRangeModal } from './custom-range-modal';
import { CustomizeImgModal } from './customize-img-modal';
import { DeleteDealCompanyModal } from './delete-deal-company-modal';
import { DemandEntryModal } from './demand-entry-modal';
import { DemandRemoveModal } from './demand-remove-modal';
import { EntityStatusAlertModal } from './entity-status-alert-modal';
import { FundJobTitleEditModal } from './fund-job-title-edit-modal';
import { FundRemoveUserModal } from './fund-remove-user-modal';
import { FundDescriptionModal } from './funds-description-modal';
import { GammaTeamMemberAdd } from './gamma-team-member-add';
import { GammaTeamMemberDelete } from './gamma-team-member-delete';
import { GammaTeamMemberEdit } from './gamma-team-member-edit';
import { HeadshotModal } from './headshot-modal';
import { KycStartModal } from './kyc-start-modal';
import { ManualAttributionModal } from './manual-attribution';
import { NotificationModal } from './notification-modal';
import { ProfileRequirementsModal } from './profile-requirements-modal';
import { QrCodeModal } from './qr-code-modal';
import { RejectActionModal } from './reject-action-modal';
import { RejectModal } from './reject-modal';
import { ReplaceFundDocumentModal } from './replace-fund-document-modal';
import { RestoreActionModal } from './restore-action-modal';
import { SignDocumentModal } from './sign-document-modal';
import { TableLegendModal } from './table-legend-modal';
import { TeamMemberAdd } from './team-member-add';
import { TeamMemberDelete } from './team-member-delete';
import { TeamMemberEdit } from './team-member-edit';

export const Modals = () => {
  const { user } = useGetUserProfile();

  //If the modal is not required for the user, return instead of null
  if (!user) return null;
  return (
    <>
      <AddressBookCategoriesModal />
      <KycStartModal />
      <TeamMemberAdd />
      <TeamMemberEdit />
      <TeamMemberDelete />
      <GammaTeamMemberAdd />
      <GammaTeamMemberEdit />
      <GammaTeamMemberDelete />
      <FundDescriptionModal />
      <HeadshotModal />
      <CustomRangeModal />
      <FundJobTitleEditModal />
      <FundRemoveUserModal />
      <NotificationModal />
      <CreateNewFundModal />
      <TableLegendModal />
      <SignDocumentModal />
      <CustomizeImgModal />
      <ConfirmActionModal />
      <BlockActionModal />
      <QrCodeModal />
      <RejectActionModal />
      <RestoreActionModal />
      <AddFundDocumentModal />
      <ReplaceFundDocumentModal />
      <RejectModal />
      <EntityStatusAlertModal />
      <ProfileRequirementsModal />
      <DeleteDealCompanyModal />
      <DemandEntryModal />
      <DemandRemoveModal />
      <ManualAttributionModal />
    </>
  );
};
